import { HttpRequest } from './HttpRequest'

export const GetTransferPlanningBankByUnitIdAndTransferId = async (unitId: string, bookingId: string, transferid: string) => {
    try {
        const response = await HttpRequest().get(`/bank/used/unitid/${unitId}/bookingId/${bookingId}/transferid/${transferid}`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}

export interface IGetTransferPlanningBankByUnitIdAndTransferId {
    id: number
    unitId: number
    bankId: number
    recoverDate: string
    usedBankId: number
    approveFinanceAmt: string
    interest: string
    approveCreditPercent: string
    approveDate: string
    creditStatusId: number
    creditReasonStatusId: number
    crRemarkBank: string
    noOrder: number
  }